/**
 * Walk a Storyblok/ProseMirror richtext tree and collect visible copy.
 * Only `text` leaves and nested `content` arrays count — node `type` names,
 * marks and attrs (href, src, …) must not leak into reading-time estimates.
 */
export function extractRichtextPlainText(node: unknown): string {
	if (node == null) {
		return '';
	}

	if (Array.isArray(node)) {
		return node.map(extractRichtextPlainText).filter(Boolean).join(' ');
	}

	if (typeof node !== 'object') {
		return '';
	}

	const record = node as Record<string, unknown>;
	const parts: string[] = [];

	if (typeof record.text === 'string' && record.text) {
		parts.push(record.text);
	}

	if (record.content != null) {
		const childText = extractRichtextPlainText(record.content);
		if (childText) {
			parts.push(childText);
		}
	}

	return parts.join(' ');
}
